// extracted by mini-css-extract-plugin
export default {"emptyLibrary":"EmptyLibrary-module__emptyLibrary_uiNk1","text":"EmptyLibrary-module__text_WBFta"};